module.exports = __webpack_public_path__ + "img/puiva_building.07943ca6.jpg";